module.exports = __webpack_public_path__ + "img/rating--average.5fc94010.svg";